export enum HTMLTagTypes {
  Image = 'IMG',
  Anchor = 'A',
}
